// A simple utility for functional composition.

const pipe = (...funcs) =>
  (args) => funcs.reduce((prev, fn) => fn(prev), args);

export default pipe;
